var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataTable',{attrs:{"url":_vm.api.ACTIONS.EVENTS,"titles":_vm.titles,"fields-hidden-main":['deleted_at', 'updated_at'],"fields-hidden-add":['id', 'deleted_at', 'created_at', 'updated_at'],"fields-hidden-edit":[
      'deleted_at',
      'created_at',
      'updated_at',
      'registered_drivers',
    ],"formatter":_vm.formatters,"title":_vm.$t('maps.events.events'),"sortBy":"start_date","enableAdd":false,"actions-extra-main":_vm.actionsExtraMain,"fieldsDisabledEdit":[
      'created_at',
      'deleted_at',
      'updated_at',
      'id',
      'start_date',
      'end_date',
      'name',
      'registered_drivers',
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }